import { UserInfo } from '@asset/type/userType';
import { create } from 'zustand';
import { useQueryParamsStore } from '@store/queryParamsStore';

export const LOCAL_STORAGE_KEY_LOGGED_IN = 'loggedIn';
export const LOCAL_STORAGE_KEY_LAST_USER_ID = 'lastUserId';

interface UserState {
  user: UserInfo | null;
  logIn: (userInfo: UserInfo | null) => void;
  logOut: () => void;
  isLoggedIn: () => boolean;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  logIn: (userInfo) => {
    const currentUserId = userInfo?.userId ?? null;
    const prevUserId =
      typeof window !== 'undefined'
        ? localStorage.getItem(LOCAL_STORAGE_KEY_LAST_USER_ID)
        : null;

    const isUserChanged =
      !currentUserId || prevUserId !== String(currentUserId);
    if (isUserChanged) useQueryParamsStore.getState().resetQueryParams();

    set({ user: userInfo });

    if (typeof window !== 'undefined') {
      if (currentUserId) {
        localStorage.setItem(
          LOCAL_STORAGE_KEY_LAST_USER_ID,
          String(currentUserId),
        );
      }
      localStorage.setItem(LOCAL_STORAGE_KEY_LOGGED_IN, 'true');
    }
  },
  logOut: () => {
    set({ user: null });
    useQueryParamsStore.getState().resetQueryParams();
    if (typeof window !== 'undefined') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_LOGGED_IN);
      localStorage.removeItem(LOCAL_STORAGE_KEY_LAST_USER_ID);
    }
  },
  isLoggedIn: () => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(LOCAL_STORAGE_KEY_LOGGED_IN) === 'true';
  },
}));
